import _merge from 'lodash.merge';
import * as MediaPlayerActions from '../player.actions';
import { initSubscriptions } from './events-subscriptions';
import { MEDIA_TRACKING } from '@medscape-promo/medscapetv/omniture-tracking';
// window.akamai.amp is created from the media players modules

function loadPlugins() {
    if (window.akamai.amp.AMP.plugins.MediaHtmlTitle == null) {
        require('../plugins/media-html-title');
    }
    if (window.akamai.amp.AMP.plugins.TrackingPixels == null) {
        require('../plugins/tracking-pixels');
    }
}
const createPlayer = (storeAPI, mediaConfig, containerEl) => {
    //console.log("[MediaPlayer Middleware] createPlayer - config:",mediaConfig,"\nContainer:",containerEl);

    const tracking = {
        toolin: "video-mtv",
        moduleName: MEDIA_TRACKING.mmodule

    }
    const { videoId } = mediaConfig;

    let playerNode = document.createElement('div');
    playerNode.classList.add('player-container');
    //console.log("[MediaPlayer] Create mediaConfig:",mediaConfig);
    import('@medscape/streaming-video-player').then(module => {

        //console.log("[SVP] Imported:", module);
        loadPlugins();
        const { StreamingVideoPlayer } = module;
        const config = _merge({},mediaConfig,{
            plugins: {
                MediaHtmlTitle: {
                    "show": mediaConfig.showTitle
                }
            }
        })
        //console.log("[Player Middleware] createPlayer - mediaConfig:",mediaConfig);
        let player = new StreamingVideoPlayer(playerNode, config, tracking);
        window.player = player;
        //console.log("[MediaPlayer] Create Player:",player);
        player.create().then(amp => {
                initSubscriptions(storeAPI, amp);
                storeAPI.dispatch(MediaPlayerActions.playerCreated(player, videoId));
            },
            error => {
                console.error("[MediaPlayer] Failed To Create!");

            });
        if(containerEl != null) {
            containerEl.innerHTML = "";
            containerEl.appendChild(player.containerEl);
        }

    })

}
export default createPlayer;